import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { isEqual } from 'lodash';
import twitterText from 'twitter-text';
import Snackbar from 'material-ui/Snackbar';
import RaisedButton from 'material-ui/RaisedButton';
import { getFeedbackBySubjectId, postFeedback } from 'redux/modules/feedback';
import { unlinkGroupPost } from 'redux/modules/groupPosts';
import { nullifyPublishAt, orgInitialState, removeAllImages, removeVideo, submitPost, wipeLinkData, populateComposebox, setPostTimeType, updatePublishAt, toggleQueuedPost, setDraftPostAutoScheduleState } from 'redux/modules/composeboxForm';
import { getOrgPosts } from 'redux/modules/schedule';
import { ChatPopup, FormSection, PageHeader } from 'components';
import { AdBoostArea, DraftPublishArea, MessageArea, PostToArea, PostTypeArea, ScheduleArea, DraftAutoScheduleArea } from 'components/Composebox';
import * as styles from './Composebox.scss';
import { tiePostToAd } from 'redux/modules/adsPlanner';
import moment from 'moment';
import Toggle from 'material-ui/Toggle';
var ComposeboxForm = (_dec = connect(function (state) {
  var _state$schedule$posts;

  var orgId = state.organization.current.id;
  return {
    config: state.config,
    composeboxForm: state.composeboxForm["".concat(orgId)] || orgInitialState,
    isUsingInitialState: !state.composeboxForm["".concat(orgId)],
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    submittingPost: state.composeboxForm.submittingPost,
    previousPath: state.app.previousPath,
    feedbackThreadsByDraftPostId: state.feedback.feedbackThreadsByDraftPostId,
    isLikeableUser: state.config.userType.isLikeableUser,
    isPartnerUser: state.config.userType.isPartner,
    user: state.auth.user,
    selectedTimezone: state.organization.selectedOrgDetails[orgId].OrganizationTimezone,
    orgPosts: (_state$schedule$posts = state.schedule.posts) !== null && _state$schedule$posts !== void 0 && _state$schedule$posts[orgId] ? state.schedule.posts[orgId] : [],
    loadingUrl: state.schedule.loadingUrl,
    loadedUrls: state.schedule.loadedUrls,
    loadingPosts: state.schedule.loadingPosts
  };
}, {
  getFeedbackBySubjectId: getFeedbackBySubjectId,
  getOrgPosts: getOrgPosts,
  nullifyPublishAt: nullifyPublishAt,
  populateComposebox: populateComposebox,
  postFeedback: postFeedback,
  removeAllImages: removeAllImages,
  removeVideo: removeVideo,
  setDraftPostAutoScheduleState: setDraftPostAutoScheduleState,
  setPostTimeType: setPostTimeType,
  submitPost: submitPost,
  tiePostToAd: tiePostToAd,
  toggleQueuedPost: toggleQueuedPost,
  unlinkGroupPost: unlinkGroupPost,
  updatePublishAt: updatePublishAt,
  wipeLinkData: wipeLinkData
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ComposeboxForm, _Component);

  var _super = _createSuper(ComposeboxForm);

  function ComposeboxForm(props) {
    var _this;

    _classCallCheck(this, ComposeboxForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchCalendarPosts", function () {
      var y = moment().format('YYYY');
      var m = moment().format('MM');
      var d = '01';
      var mom = moment("".concat(y, "-").concat(m, "-").concat(d));
      var monthStart = moment(mom).startOf('month');
      var from = monthStart.subtract(monthStart.day(), "days");
      var monthEnd = moment(mom).endOf('month');
      var to = monthEnd.add(6 - monthEnd.day(), "days");

      _this.props.getOrgPosts(_this.props.organization.id, _this.props.selectedTimezone, from, to, false);
    });

    _defineProperty(_assertThisInitialized(_this), "constructPostMap", function (posts) {
      var map = {};

      for (var i = 0; i < posts.length; i++) {
        var cur = moment(posts[i].publishAt);
        var end = moment(posts[i].publishAt);

        while (cur.isSame(end, 'day') || cur.isBefore(end, 'day')) {
          var key = "".concat(cur.clone().startOf('day').valueOf());

          if (!map[key]) {
            map[key] = [];
          }

          map[key].push({
            key: posts[i].id,
            startTime: moment(posts[i].publishAt).toDate(),
            endTime: moment(posts[i].publishAt).add(15, 'minutes').toDate(),
            title: moment(posts[i].start).format('h:mm A')
          });
          cur.add(1, 'day');
        }
      }

      _this.setState({
        schedulePostMap: map
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      var existingPostId = _this.props.composeboxForm.existingPostId;
      var accountSelected = false;
      var numberSelectedAccounts = 0;

      _.forEach(_this.props.composeboxForm.selectedAccounts, function (value, key) {
        if (value) {
          numberSelectedAccounts += 1;
          accountSelected = true;
        }
      });

      if (accountSelected) {
        if (_this.props.composeboxForm.selectedAccounts.twitter) {
          var message = _this.props.composeboxForm.messages.twitter ? _this.props.composeboxForm.messages.twitter : _this.props.composeboxForm.messages.global;

          if (280 - twitterText.getTweetLength(message) < 0) {
            if (window.confirm(numberSelectedAccounts > 1 ? 'This message is too long for X (Twitter) and will not be posted. Would you like to schedule this post anyway?' : 'This message is too long for X (Twitter).') && numberSelectedAccounts > 1) {
              console.log('okie dokie');
            }
          }
        }

        if (_this.props.composeboxForm.selectedAccounts.instagram) {
          var _message = _this.props.composeboxForm.messages.instagram ? _this.props.composeboxForm.messages.instagram : _this.props.composeboxForm.messages.global;

          if (2200 - _message.length < 0) {
            if (window.confirm(numberSelectedAccounts > 1 ? 'This message is too long for Instagram and will be cut to 2200 characters. Would you like to schedule this post anyway?' : 'This message is too long for Instagram.') && numberSelectedAccounts > 1) {
              console.log('okie dokie');
            }
          }

          if (_message.includes('#')) {
            var count = (_message.match(/(^|\B)#(?![0-9_]+\b)([a-zA-Z0-9_]{1,})(\b|\r)/g) || []).length;

            if (count > 30) {
              if (window.confirm(numberSelectedAccounts > 1 ? 'This message contains too many tags for an Instagram post and will not be posted. Would you like to schedule this post anyway?' : 'This message contains too many tags for an Instagram post. Limit: 30') && numberSelectedAccounts > 1) {
                console.log('okie dokie');
              }
            }
          }
        }

        _this.props.submitPost(_this.props.composeboxForm, _this.props.organizationId).then(function (_ref) {
          var data = _ref.data;

          // check if group post and detach if it was
          if (_this.state.isGroupPost) {
            _this.props.unlinkGroupPost(existingPostId, _this.props.organizationId);
          }

          if (_this.props.composeboxForm.fromPlannedAd && _this.props.composeboxForm.fromPlannedAd.id) {
            return _this.props.tiePostToAd(_this.props.organization.id, _this.props.composeboxForm.fromPlannedAdCategory.AdsPlannerId, data.id, _this.props.composeboxForm.fromPlannedAd.id, moment(_this.props.composeboxForm.publishAt).format(), moment(_this.props.composeboxForm.publishAt).add(parseInt(Math.floor(parseInt(_this.props.composeboxForm.fromPlannedAd.budget) / 200.0)), 'days').format());
          }

          return Promise.resolve();
        }).then(function () {
          // don't allow skipping to different tab when composebox is closed
          if (_this.props.previousPath && _this.props.previousPath.includes(_this.props.organizationId)) {
            _this.context.router.goBack();
          } else {
            browserHistory.push("/org/".concat(_this.props.organizationId, "/publishing/schedule"));
          }
        })["catch"](function (err) {
          console.error(err);
        });
      } else {
        _this.setState({
          showSnackbar: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePostFeedback", function (value, draftId) {
      _this.props.postFeedback({
        orgId: _this.props.organization.id,
        message: value,
        subjectType: 'DraftPost',
        subjectId: _this.props.composeboxForm.DraftPost.id
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getQueueName", function () {
      if (_this.props.composeboxForm.selectedAccounts.facebookProfile) return 'Facebook Profile';
      if (_this.props.composeboxForm.selectedAccounts.facebookPage) return 'Facebook Page';
      if (_this.props.composeboxForm.selectedAccounts.twitter) return 'Twitter';
    });

    _this.state = {
      showSnackbar: false,
      snackbarMessage: 'Required fields missing.',
      isGroupPost: false,
      schedulePostMap: []
    };
    return _this;
  }

  _createClass(ComposeboxForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchCalendarPosts();
      this.constructPostMap(this.props.orgPosts);

      if (!!this.props.composeboxForm.existingPostId && this.props.composeboxForm.existingPostId.includes('group_post')) {
        this.setState({
          isGroupPost: true
        });
      }

      if (!!this.props.composeboxForm.DraftPost && this.props.composeboxForm.DraftPost.id) {
        this.props.getFeedbackBySubjectId(this.props.organizationId, this.props.composeboxForm.DraftPost.id);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.composeboxForm && !this.props.composeboxForm || !prevProps.isUsingInitialState && this.props.isUsingInitialState) {
        // clearing on close here
        this.props.populateComposebox({}, this.props.organizationId);
        this.setState({
          isGroupPost: false
        });
      }

      if (!isEqual(prevProps.orgPosts, this.props.orgPosts)) {
        this.constructPostMap(this.props.orgPosts);
      }
    }
  }, {
    key: "render",
    value:
    /** *********************************************************
      RENDER
      ***********************************************************/
    function render() {
      var _this2 = this,
          _composeboxForm$Draft,
          _this$props$feedbackT,
          _this$props$feedbackT2,
          _this$props$feedbackT3;

      var composeboxForm = this.props.composeboxForm;
      var unapprovedDraft = composeboxForm.DraftPost && composeboxForm.DraftPost.id && !composeboxForm.DraftPost.approvedAt && !composeboxForm.publishAt;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: composeboxForm ? composeboxForm.existingPostId ? 'Edit Post' : 'New Post' : '',
        style: {
          marginBottom: 16
        }
      })), this.state.isGroupPost && /*#__PURE__*/React.createElement("div", {
        className: "row ".concat(styles.groupPostWarning)
      }, "This is a group post, scheduled for you by ", this.props.organization.parentOrganization.name, ". If you make edits it will be disconnected from the group post and saved as a regular post."), /*#__PURE__*/React.createElement(FormSection, {
        title: "Post To"
      }, !composeboxForm.existingPostQueueId || composeboxForm.convertQueuedPost ? /*#__PURE__*/React.createElement(PostToArea, null) : /*#__PURE__*/React.createElement("span", null, "This post is in your ", this.getQueueName(), " queue.")), /*#__PURE__*/React.createElement(FormSection, {
        title: "Message",
        titleStyle: {
          marginBottom: 0
        }
      }, /*#__PURE__*/React.createElement(MessageArea, null)), /*#__PURE__*/React.createElement(FormSection, {
        title: "Post Type"
      }, /*#__PURE__*/React.createElement(PostTypeArea, null)), composeboxForm.fromPlannedAd && composeboxForm.fromPlannedAd.name && /*#__PURE__*/React.createElement(FormSection, {
        title: "Ad Boost"
      }, /*#__PURE__*/React.createElement(AdBoostArea, null)), !unapprovedDraft && (!composeboxForm.existingPostQueueId || !!composeboxForm.existingPostQueueId && !!composeboxForm.convertQueuedPost) && /*#__PURE__*/React.createElement(FormSection, null, /*#__PURE__*/React.createElement(DraftPublishArea, {
        onChange: function onChange(val) {
          if (val === 'publishNow') {
            _this2.props.updatePublishAt(new Date().getTime(), _this2.props.organizationId);
          } else if (val === 'draft') {
            _this2.props.updatePublishAt(null, _this2.props.organizationId);
          } else if (val === 'schedule') {
            _this2.props.updatePublishAt(new Date().getTime(), _this2.props.organizationId);
          }

          _this2.props.setPostTimeType(_this2.props.organizationId, val);
        },
        isSchedule: composeboxForm.publishAt && moment(composeboxForm.publishAt).isAfter(moment(), 'minute'),
        publishAt: composeboxForm.publishAt ? composeboxForm.publishAt : null
      })), composeboxForm.postTimeType === 'draft' && /*#__PURE__*/React.createElement(FormSection, {
        title: [/*#__PURE__*/React.createElement("span", {
          key: "drafttoggletitle"
        }, "Auto Schedule Draft"), /*#__PURE__*/React.createElement(Toggle, {
          style: {
            marginLeft: 10,
            width: 'auto',
            display: 'inline-block'
          },
          key: "drafttoggle",
          toggled: composeboxForm.draftPostToggleState,
          onToggle: function onToggle(e, val) {
            _this2.props.setDraftPostAutoScheduleState(_this2.props.organizationId, val);
          }
        })]
      }, /*#__PURE__*/React.createElement("em", {
        style: {
          fontSize: 13,
          padding: 5
        }
      }, "Enabling Auto Schedule will instantly schedule this post after it has been approved."), composeboxForm.draftPostToggleState && /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("p", null, "When should this post be scheduled for?"), /*#__PURE__*/React.createElement(DraftAutoScheduleArea, {
        loadPosts: this.props.getOrgPosts,
        schedulePostMap: this.state.schedulePostMap
      }))), (composeboxForm.postTimeType === 'schedule' || !!composeboxForm.existingPostQueueId && !composeboxForm.convertQueuedPost) && /*#__PURE__*/React.createElement(FormSection, {
        title: '',
        titleStyle: {
          display: 'none'
        }
      }, /*#__PURE__*/React.createElement(ScheduleArea, {
        loadPosts: this.props.getOrgPosts,
        schedulePostMap: this.state.schedulePostMap
      })), composeboxForm.postType === 'videoPost' && composeboxForm.selectedAccounts.googleMybusiness && /*#__PURE__*/React.createElement("p", {
        style: {
          color: '#6b91b3',
          fontStyle: 'italic',
          padding: 6,
          background: '#e7f2f5',
          border: '1px solid #6b91b3',
          borderRadius: 6
        },
        id: "test-gmb-video-info"
      }, /*#__PURE__*/React.createElement("i", {
        "class": "fa fa-info-circle",
        "aria-hidden": "true"
      }), ' ', /*#__PURE__*/React.createElement("strong", null, "Google My Business does not support Video posts."), " This post can be posted to other networks, but Google My Business will not be submitted."), composeboxForm.postType === 'imagePost' && composeboxForm.selectedAccounts.googleMybusiness && composeboxForm.images.length > 1 && /*#__PURE__*/React.createElement("p", {
        style: {
          color: '#6b91b3',
          fontStyle: 'italic',
          padding: 6,
          background: '#e7f2f5',
          border: '1px solid #6b91b3',
          borderRadius: 6
        },
        id: "test-gmb-img-info"
      }, /*#__PURE__*/React.createElement("i", {
        "class": "fa fa-info-circle",
        "aria-hidden": "true"
      }), ' ', /*#__PURE__*/React.createElement("strong", null, "Google My Business does not support multiple images."), " This post will be posted with the first image you've selected."), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          flexWrap: 'wrap'
        }
      }, this.props.organization.gracePeriodState === '2' && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "This functionality has been disabled because this client's account is past due."), !!composeboxForm.convertQueuedPost && /*#__PURE__*/React.createElement(RaisedButton, {
        style: {
          marginRight: 20
        },
        label: "Keep in Queue",
        onClick: function onClick() {
          return _this2.props.toggleQueuedPost(_this2.props.organization.id);
        }
      }), this.props.organization.gracePeriodState !== '2' && (!composeboxForm.existingPostQueueId || !!composeboxForm.existingPostQueueId && !!composeboxForm.convertQueuedPost) && /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: function () {
          switch (composeboxForm.postTimeType) {
            case 'publishNow':
              return 'Publish Post';

            case 'draft':
              return 'Save Draft';

            default:
              return 'Schedule Post';
          }
        }(),
        onClick: this.handleSubmit,
        disabled: this.props.submittingPost || this.props.organization.gracePeriodState === '2'
      }), this.props.organization.gracePeriodState !== '2' && !!composeboxForm.existingPostQueueId && !composeboxForm.convertQueuedPost && /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Save",
        onClick: this.handleSubmit,
        disabled: this.props.submittingPost || this.props.organization.gracePeriodState === '2'
      })), (this.props.isPartnerUser || this.props.isLikeableUser) && !!(composeboxForm !== null && composeboxForm !== void 0 && (_composeboxForm$Draft = composeboxForm.DraftPost) !== null && _composeboxForm$Draft !== void 0 && _composeboxForm$Draft.id) && /*#__PURE__*/React.createElement(ChatPopup, {
        open: !!((_this$props$feedbackT = this.props.feedbackThreadsByDraftPostId) !== null && _this$props$feedbackT !== void 0 && (_this$props$feedbackT2 = _this$props$feedbackT[parseInt(composeboxForm.DraftPost.id)]) !== null && _this$props$feedbackT2 !== void 0 && _this$props$feedbackT2.FeedbackMessages.length),
        handlePostFeedback: this.handlePostFeedback,
        user: this.props.user,
        feedbackThread: ((_this$props$feedbackT3 = this.props.feedbackThreadsByDraftPostId) === null || _this$props$feedbackT3 === void 0 ? void 0 : _this$props$feedbackT3[parseInt(composeboxForm.DraftPost.id)]) || []
      }), /*#__PURE__*/React.createElement(Snackbar, {
        open: this.state.showSnackbar,
        message: this.state.snackbarMessage,
        autoHideDuration: 4000,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            showSnackbar: false
          });
        }
      }));
    }
  }]);

  return ComposeboxForm;
}(Component), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object.isRequired
}), _temp)) || _class);
export { ComposeboxForm as default };